import { toast } from "react-toastify";
import { CalendarConstants } from "../_constants";
import { CalendarService } from "../_services";

export const CalendarActions = {
  get,
  getByChronicle,
  // getByWorld,
  create,
  update,
  delete: deleteCalendar,
};

function get(calendarID) {
  return (dispatch) => {
    dispatch(request(calendarID));

    return CalendarService.fetchById(calendarID).then(
      (calendar) => {
        dispatch(success(calendar));
        return calendar;
      },
      (error) => {
        //Dev Mode only!
        toast.error(`Unable to retrieve Calendar ID ${calendarID}`);
        dispatch(failure(error.toString()));
        return error;
      }
    );
  };

  function request(params) {
    return {
      type: CalendarConstants.FETCH_BY_ID_REQUEST,
      params,
    };
  }

  function success(calendar) {
    return {
      type: CalendarConstants.FETCH_BY_ID_SUCCESS,
      payload: calendar,
    };
  }

  function failure(error) {
    return {
      type: CalendarConstants.FETCH_BY_ID_FAILURE,
      error,
    };
  }
}

function getByChronicle(chronicleID) {
  return (dispatch) => {
    dispatch(request(chronicleID));

    return CalendarService.fetchByChronicle(chronicleID).then(
      (calendars) => {
        dispatch(success(calendars));
        return calendars;
      },
      (error) => {
        //Dev Mode only!
        toast.error("Unable to retrieve Calendars for Chronicle");
        dispatch(failure(error.toString()));
        return error;
      }
    );
  };

  function request(params) {
    return {
      type: CalendarConstants.FETCH_CALENDARS_BY_CHRONICLE_REQUEST,
      params,
    };
  }

  function success(calendars) {
    return {
      type: CalendarConstants.FETCH_CALENDARS_BY_CHRONICLE_SUCCESS,
      payload: calendars,
    };
  }

  function failure(error) {
    return {
      type: CalendarConstants.FETCH_CALENDARS_BY_CHRONICLE_FAILURE,
      error,
    };
  }
}

function create(calendarData) {
  return (dispatch) => {
    dispatch(request(calendarData));

    return CalendarService.createNew(calendarData).then(
      (calendar) => {
        toast.success(`Successfully created Calendar ${calendar.name}`);
        dispatch(success(calendar));
        return calendar;
      },
      (error) => {
        toast.error("Unable to create new Calendar.");
        dispatch(failure(error.toString()));
        return error;
      }
    );
  };

  function request(params) {
    return {
      type: CalendarConstants.CREATE_NEW_REQUEST,
      params,
    };
  }

  function success(calendar) {
    return {
      type: CalendarConstants.CREATE_NEW_SUCCESS,
      payload: calendar,
    };
  }

  function failure(error) {
    return {
      type: CalendarConstants.CREATE_NEW_FAILURE,
      error,
    };
  }
}

function update(calendarID, calendarData, overrideToast = false) {
  return (dispatch) => {
    dispatch(request());

    return CalendarService.update(calendarID, calendarData).then(
      (calendar) => {
        if (overrideToast) {
          toast.success(`Successfully updated Calendar ${calendar.name}!`);
        }
        dispatch(success(calendar));
        return calendar;
      },
      (error) => {
        dispatch(failure(error.toString()));
        return error;
      }
    );
  };

  function request(params) {
    return {
      type: CalendarConstants.UPDATE_REQUEST,
      params,
    };
  }

  function success(calendar) {
    return {
      type: CalendarConstants.UPDATE_SUCCESS,
      payload: calendar,
    };
  }

  function failure(error) {
    return {
      type: CalendarConstants.UPDATE_FAILURE,
      error,
    };
  }
}

function deleteCalendar(calendarID) {
  return (dispatch) => {
    dispatch(request());

    return CalendarService.delete(calendarID).then(
      () => {
        toast.success("Successfully deleted Calendar!");
        dispatch(success(calendarID));
        return calendarID;
      },
      (error) => {
        toast.error("Unable to delete Calendar.");
        dispatch(failure(error.toString()));
        return error;
      }
    );
  };

  function request(params) {
    return {
      type: CalendarConstants.DELETE_REQUEST,
      params,
    };
  }

  function success(calendarID) {
    return {
      type: CalendarConstants.DELETE_SUCCESS,
      payload: calendarID,
    };
  }

  function failure(error) {
    return {
      type: CalendarConstants.DELETE_FAILURE,
      error,
    };
  }
}
